export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Expansive%20overhead%20flat%20lay%20of%20curated%20fashion%20items%20including%20white%20sneakers%20beige%20hoodie%20tan%20leather%20bag%20and%20gold%20accessories%20artistically%20scattered%20on%20light%20grey%20concrete%20textured%20surface%2C%20editorial%20product%20photography%20with%20soft%20morning%20sunlight%20from%20top%20left%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20palette%2C%20organic%20composition%20with%20gentle%20shadows&width=1800&height=1000&seq=hero-pandabuy-v2-020&orientation=landscape"
        alt="Curated pandabuy spreadsheet fashion finds collection"
        title="pandabuy spreadsheet fashion finds 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="flex-1 text-center lg:text-left">
          <div className="flex items-center justify-center lg:justify-start gap-2 mb-6">
            <div className="flex -space-x-3">
              <img src="https://readdy.ai/api/search-image?query=Close-up%20portrait%20of%20young%20person%20with%20warm%20smile%20on%20soft%20peach%20background%2C%20clean%20minimalist%20headshot%2C%20bright%20natural%20window%20lighting&width=80&height=80&seq=hero-avatar-v2-021&orientation=squarish" alt="" className="w-9 h-9 rounded-full border-2 border-white/80 object-cover" />
              <img src="https://readdy.ai/api/search-image?query=Close-up%20portrait%20of%20young%20person%20with%20confident%20look%20on%20light%20lavender%20background%2C%20clean%20minimalist%20headshot%2C%20soft%20natural%20side%20lighting&width=80&height=80&seq=hero-avatar-v2-022&orientation=squarish" alt="" className="w-9 h-9 rounded-full border-2 border-white/80 object-cover" />
              <img src="https://readdy.ai/api/search-image?query=Close-up%20portrait%20of%20young%20person%20with%20friendly%20expression%20on%20soft%20mint%20background%2C%20clean%20minimalist%20headshot%2C%20gentle%20natural%20front%20lighting&width=80&height=80&seq=hero-avatar-v2-023&orientation=squarish" alt="" className="w-9 h-9 rounded-full border-2 border-white/80 object-cover" />
            </div>
            <span className="text-white/80 text-xs md:text-sm">Trusted by 5,000+ hunters</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white leading-tight mb-6">
            Discover the Best<br />
            <span className="font-sans font-light text-3xl md:text-5xl lg:text-6xl">pandabuyspreadsheet Finds</span>
          </h1>

          <p className="text-white/70 text-sm md:text-base max-w-md mx-auto lg:mx-0 mb-8 leading-relaxed">
            Explore curated spreadsheets for sneakers, streetwear, luxury fashion, and daily essentials — updated weekly with the best budget-friendly finds.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-950 font-medium text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer group"
            >
              Pandabuy Sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white text-sm font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Browse Categories
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>

        <div className="hidden lg:block flex-1">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-md ml-auto border border-white/15">
            <p className="text-white/85 text-base leading-relaxed font-light">
              pandabuyspreadsheet is a curated system that helps users quickly discover high-quality product listings through organized spreadsheets. Instead of searching endlessly, access structured lists with pricing, quality ratings, and comparisons.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}